import { Trip } from "../models/trip";

export function  getTripDurationInMin(trip : Trip) {
    var date = new Date(null);
    var days = Math.floor(trip.duration / 86400);
    date.setSeconds(trip.duration); // specify value for SECONDS here
    if (days > 0) {
       trip.durationToDisplay = date.toISOString().substr(11, 8) + ' + ' + days+'j';
    } else
    {
       trip.durationToDisplay = date.toISOString().substr(11, 8);
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/commons-utils.ts